import script from "./NewSessionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewSessionModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewSessionModal.vue?vue&type=style&index=0&id=84d18d6c&lang=scss"

const __exports__ = script;

export default __exports__